import { Button } from '@civilgrid/ui/components';
import { useMutation } from '@tanstack/react-query';
import { syncExtractProjections } from '~/api/extract';
import { Notify } from '~/components2/Notify';
import { MajorHeading } from '../common/Heading';

export default function SyncProjections() {
  const mutation = useMutation({
    mutationFn: syncExtractProjections,
    onSuccess: () => {
      Notify.info({
        title: 'Sync Extract Projections',
        message: 'Projection sync started. New projections will appear once the job completes.',
      });
    },
    onError: () => {
      Notify.error({
        title: 'Sync Extract Projections',
        message: 'An error occurred while starting the projection sync. Check logs for details.',
      });
    },
  });

  return (
    <div>
      <MajorHeading tooltip="Re-imports the FME projection list from ESRI (data.fme_epsg). New projections are added, reappearing ones reactivated, and projections no longer in ESRI are archived.">
        Sync Extract Projections
      </MajorHeading>
      <Button
        onClick={() => mutation.mutate()}
        loading={mutation.isPending}
        disabled={mutation.isPending}
        data-testid="extract-sync-projections-button"
      >
        Sync Projections
      </Button>
    </div>
  );
}
